(function () {
  const popup = document.querySelector('.cart-popup');
  if (!popup) return;
  const panel = popup.querySelector('#cart-popup-panel');
  const backdrop = popup.querySelector('[data-cart-popup-backdrop]');

  function open(triggerEl) {
    popup.setAttribute('aria-hidden', 'false');
    const focusEl = panel || popup;
    if (typeof window.trapFocus === 'function') {
      window.trapFocus(popup, focusEl);
    } else {
      focusEl.setAttribute('tabindex', '-1');
      focusEl.focus({ preventScroll: true });
    }

    // Update cart title when opening popup
    updateCartTitleOnOpen();

    // Also update via cart-popup-items if it exists
    const cartPopupItems = document.querySelector('cart-popup-items');
    if (cartPopupItems && typeof cartPopupItems.updateCartTitle === 'function') {
      setTimeout(() => cartPopupItems.updateCartTitle(), 100);
    }
  }

  async function updateCartTitleOnOpen() {
    const cartTitle = document.querySelector('#cart-popup-title');
    if (!cartTitle) return;

    const panel = document.querySelector('#cart-popup-panel');
    const textItemSingular = panel?.dataset.textItemSingular || '1 Item';
    const textItemPlural = panel?.dataset.textItemPlural || '{{ count }} items';

    try {
      // Get fresh cart data from Shopify
      const response = await fetch('/cart.js');
      const cart = await response.json();

      // Calculate total quantity from actual cart data
      const totalQuantity = cart.items ? cart.items.reduce((sum, item) => sum + item.quantity, 0) : 0;

      // Update title text
      if (totalQuantity === 1) {
        cartTitle.textContent = textItemSingular.replace('__COUNT__', totalQuantity);
      } else {
        cartTitle.textContent = textItemPlural.replace('__COUNT__', totalQuantity);
      }
    } catch (error) {
      // Fallback to cart bubble
      const cartBubble = document.querySelector('#cart-icon-bubble .cart-count-bubble');
      if (cartBubble) {
        const itemCount = parseInt(cartBubble.textContent.trim()) || 0;
        if (itemCount === 1) {
          cartTitle.textContent = textItemSingular.replace('__COUNT__', itemCount);
        } else {
          cartTitle.textContent = textItemPlural.replace('__COUNT__', itemCount);
        }
      }
    }
  }

  function close() {
    popup.setAttribute('aria-hidden', 'true');
    if (typeof window.removeTrapFocus === 'function') {
      window.removeTrapFocus();
    }
  }

  // Wire triggers
  function bindTriggers() {
    // Header menu cart links
    const triggers = document.querySelectorAll('[data-open-cart-popup="true"], #cart-icon-bubble');
    triggers.forEach((el) => {
      // capture to preempt other listeners (e.g., cart-drawer)
      el.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopImmediatePropagation();
        e.stopPropagation();
        open(el);
      }, true);
      el.addEventListener('keydown', (e) => {
        if (e.code && e.code.toUpperCase() === 'SPACE') { e.preventDefault(); open(el); }
      });
      el.setAttribute('role', 'button');
      el.setAttribute('aria-haspopup', 'dialog');
    });
  }

  bindTriggers();

  // Backdrop & close buttons
  backdrop && backdrop.addEventListener('click', close);
  // Use event delegation for close buttons to handle dynamically added buttons
  popup.addEventListener('click', (e) => {
    if (e.target.matches('.cart-popup-close, .popup__close')) {
      e.preventDefault();
      close();
    }
  });

  // Click outside to close - more robust detection
  document.addEventListener('click', (e) => {
    const isOpen = popup.getAttribute('aria-hidden') === 'false';
    if (!isOpen) return;

    // Check if click is outside the popup panel
    if (panel && !panel.contains(e.target)) {
      close();
    }
  });

  // Escape key
  document.addEventListener('keyup', (e) => { if (e.code === 'Escape') close(); });

  // Auto-open cart popup if we're on the cart page
  function autoOpenOnCartPage() {
    const currentPath = window.location.pathname;
    const isCartPage = currentPath === '/cart' ||
      currentPath.endsWith('/cart') ||
      currentPath === '/cart/' ||
      currentPath.includes('/cart?');

    if (isCartPage) {
      // Wait for DOM to be ready and cart to be loaded
      setTimeout(() => {
        open();
      }, 100);
    }
  }

  // Run auto-open check when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', autoOpenOnCartPage);
  } else {
    autoOpenOnCartPage();
  }
})();

// Custom element for cart-popup-items
class CartPopupItems extends CartItems {
  constructor() {
    super();
  }

  connectedCallback() {
    // Subscribe to cart updates from any source
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      // If the cart update is an error (e.g. inventory/quantity exceeded),
      // don't re-render the popup section or we'll wipe the inline error message.
      if (event?.cartData?.errors) return;

      // If this popup is already mid-update, skip the redundant refresh.
      // Allow updates even if a loading state is active so header counts stay in sync

      // Update cart popup content when cart is updated from any source
      return this.onCartUpdate().then(() => {
        // Update cart title after content is refreshed
        this.updateCartTitle();

        // Dispatch event for cart header update when cart content changes
        document.dispatchEvent(new CustomEvent('cart:changed', {
          detail: event
        }));
      });
    });
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-popup-panel',
        section: 'cart-popup',
        // Replace the whole panel so header/footer/subtotal reflect the current cart
        selector: '#cart-popup-panel',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('CartPopup-CartItems');
    if (mainCartItems) {
      mainCartItems.classList.add('cart__items--disabled');
    }

    const cartItemElements = this.querySelectorAll(`#CartPopup-Item-${line} .loading__spinner`);

    cartItemElements.forEach((overlay) => {
      if (overlay) {
        overlay.classList.remove('hidden');
      }
    });

    document.activeElement.blur();
    if (this.lineItemStatusElement) {
      this.lineItemStatusElement.setAttribute('aria-hidden', false);
    }
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById('CartPopup-CartItems');
    if (mainCartItems) {
      mainCartItems.classList.remove('cart__items--disabled');
    }

    const cartItemElements = this.querySelectorAll(`#CartPopup-Item-${line} .loading__spinner`);

    cartItemElements.forEach((overlay) => {
      if (overlay) {
        overlay.classList.add('hidden');
      }
    });
  }

  async updateCartTitle() {
    const cartTitle = document.querySelector('#cart-popup-title');
    if (!cartTitle) return;

    const panel = document.querySelector('#cart-popup-panel');
    const textItemSingular = panel?.dataset.textItemSingular || '1 Item';
    const textItemPlural = panel?.dataset.textItemPlural || '{{ count }} items';

    try {
      // Add delay to ensure cart API is updated
      await new Promise(resolve => setTimeout(resolve, 300));

      // Get fresh cart data from Shopify
      const response = await fetch('/cart.js');
      const cart = await response.json();

      // Calculate total quantity from actual cart data
      const totalQuantity = cart.items ? cart.items.reduce((sum, item) => sum + item.quantity, 0) : 0;

      // Update title text
      if (totalQuantity === 1) {
        cartTitle.textContent = textItemSingular.replace('__COUNT__', totalQuantity);
      } else {
        cartTitle.textContent = textItemPlural.replace('__COUNT__', totalQuantity);
      }

      // Update header visibility
      const cartHeader = cartTitle.closest('.cart-popup-header');
      if (cartHeader) {
        if (totalQuantity === 0) {
          cartHeader.classList.add('hidden');
        } else {
          cartHeader.classList.remove('hidden');
        }
      }
    } catch (error) {
      // Fallback: count cart items in the popup
      const cartItems = this.querySelectorAll('[data-index]');
      let itemCount = 0;

      if (cartItems.length > 0) {
        cartItems.forEach(item => {
          const quantityInput = item.querySelector('input[name="updates[]"], input[type="number"]');
          if (quantityInput) {
            itemCount += parseInt(quantityInput.value) || 0;
          } else {
            itemCount += 1; // Default to 1 if no quantity input found
          }
        });
      }

      // Update title text with fallback data
      if (itemCount === 1) {
        cartTitle.textContent = textItemSingular.replace('__COUNT__', itemCount);
      } else {
        cartTitle.textContent = textItemPlural.replace('__COUNT__', itemCount);
      }

      // Update header visibility
      const cartHeader = cartTitle.closest('.cart-popup-header');
      if (cartHeader) {
        if (itemCount === 0) {
          cartHeader.classList.add('hidden');
        } else {
          cartHeader.classList.remove('hidden');
        }
      }
    }
  }
}

customElements.define('cart-popup-items', CartPopupItems);
